import { ReactComponent as DropdownIcon } from './icn_dropdown.svg';

const DownArrow = () => <DropdownIcon style={{width: '30px', height: '30px', cursor:'pointer'}}/>;

export default DownArrow;